module.exports = __webpack_public_path__ + "img/99.7a84f3e6.jpg";